import React, { Component } from 'react'
import { FormGroup, Input, Col, InputGroup, Button, InputGroupAddon, } from 'reactstrap'
import ItemSearchTypeSelector from './ItemSearchTypeSelector'
import forOwn from 'mout/object/forOwn'

class ItemSearchBar extends Component {
  constructor(props) {
    super(props)

  }

  // name, code, question, node

  render() {
    let searchBar
    let inputBar
    if (this.props.searchType !== 'node') {
      inputBar = (            
        <Input 
          type='text' 
          placeholder={`Search items by ${this.props.searchType}...`} 
          value={this.props.search}
          name='search'
          id='search'
          onChange={(e) => this.props.handleChange(e)}
        />)
    } else {
      let options = <option></option>
      if (this.props.nodes) {
        options = []
        forOwn(this.props.nodes, (val, key, o) => {
          if (!val.deleted) {
            options.push(
              <option key={'nodeOption' + val.id} value={val.id}>{val.name}</option>
            )
          }
        })
        options.splice(0, 0, <option value='' key='nullSearchNodeOption'></option>)
      }
      inputBar = (
        <Input
          type='select'
          placeholder={`Search items by ${this.props.searchType}`}
          value={this.props.search}
          name='search'
          id='search'
          onChange={(e) => this.props.handleChange(e)}
        >
          {options}
        </Input>
      )
    }

    searchBar = (
      <FormGroup row>
        <Col md='12'>
          <ItemSearchTypeSelector searchType={this.props.searchType} handleChange={this.props.handleChange} />
          <InputGroup>
            <InputGroupAddon addonType='prepend'>
              <Button disabled color='secondary'><i className='fa fa-search'></i> Search</Button>
            </InputGroupAddon>
            {inputBar}
          </InputGroup>

        </Col>
      </FormGroup>
    )

    return (
      <div>
        {searchBar}
      </div>
    )
  }
}

export default ItemSearchBar




// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentsManage/ItemSearchBar.js